var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import FormGroupHorizontal from '../FormGroupHorizontal';
var InputHorizontal = /** @class */ (function (_super) {
    __extends(InputHorizontal, _super);
    function InputHorizontal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderFeedback = function () {
            var _a = _this.props, feedback = _a.feedback, isRounded = _a.isRounded, invalid = _a.invalid, valid = _a.valid;
            if (feedback) {
                return (React.createElement("p", { className: 'mb-0 gr-feedback ' +
                        (isRounded ? 'mx-x4 ' : '') +
                        (invalid ? 'invalid ' : '') +
                        (valid ? 'valid ' : '') }, feedback));
            }
            else {
                return null;
            }
        };
        return _this;
    }
    InputHorizontal.prototype.render = function () {
        var _a = this.props, name = _a.name, type = _a.type, label = _a.label, isRequired = _a.isRequired, value = _a.value, valid = _a.valid, invalid = _a.invalid, disabled = _a.disabled, feedback = _a.feedback, onChange = _a.onChange, labelCols = _a.labelCols, inputCols = _a.inputCols, placeholder = _a.placeholder, className = _a.className, min = _a.min, max = _a.max, step = _a.step, autoFocus = _a.autoFocus, autoComplete = _a.autoComplete, isRounded = _a.isRounded, inputClassName = _a.inputClassName, id = _a.id, size = _a.size, helpText = _a.helpText;
        var newId = id ? id : name + '_' + Math.random();
        return (React.createElement(FormGroupHorizontal, { inputSize: size, className: className, leftCols: labelCols, rightCols: inputCols, isLeftLabel: true, leftContent: React.createElement("label", { htmlFor: newId, className: 'label-size ' + (isRounded ? 'horizontal-label-space' : '') }, label + (isRequired ? '*' : '')), rightContent: React.createElement(React.Fragment, null,
                React.createElement("input", { id: newId, name: name, type: type, value: value !== null && value !== void 0 ? value : '', placeholder: placeholder, autoFocus: autoFocus, required: isRequired || false, disabled: disabled, autoComplete: autoComplete ? autoComplete : 'off', min: min, max: max, step: step, className: 'w-100 gr-input ' +
                        (size ? size : 'lg') +
                        (isRounded ? ' round' : '') +
                        (valid ? ' valid ' : '') +
                        (invalid ? ' invalid ' : '') +
                        (inputClassName ? inputClassName : ''), onChange: function (evt) {
                        onChange(evt.target.value);
                    } }),
                feedback && this.renderFeedback(),
                helpText && (React.createElement("div", { className: helpText ? 'help-text ' + (isRounded ? 'rounded' : '') : '' }, helpText))) }));
    };
    return InputHorizontal;
}(PureComponent));
export default InputHorizontal;
//# sourceMappingURL=InputHorizontal.js.map